"use strict";
var core_1 = require('@angular/core');
exports.NG_MAP_CONFIG_TOKEN = new core_1.OpaqueToken('NG_MAP_CONFIG_TOKEN');
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-map/dist/services/config.js
// module id = 10
// module chunks = 0